export default "__VITE_ASSET__CIKu2Tfw__"